import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener los Sistemas creados antes de agregar componentes.',
  ],
  tips: [
    'Cada componente pertenece a un sistema: "Filtro de aceite" → Sistema "Motor".',
    'Los componentes se asocian a tareas de mantenimiento en los planes y a repuestos.',
    'Cada repuesto recomendao para un equipo que se asocie a un componente, será utilizado en las planillas de mantenimiento como repuesto asociado a la tarea correspondiente.',
    'Sé específico: "Filtro de combustible primario" es mejor que "Filtro".',
  ],
  nextSteps: [
    'Crear Tareas de mantenimiento y asignarles el componente correspondiente.',
    'Crear repuestos y asociarlos a los componentes que los utilizan.',
    'Al armar rutinas de mantenimiento, las tareas que tengan componente asociado utilizarán el repuesto del equipo que tenga el mismo componente.',
  ],
};

const ConfiguracionComponentes = () => (
  <ConfiguracionBase
    apiEndpoint="componentes"
    titulo="Componentes"
    descripcion="Componentes de equipos organizados por sistema"
    icon="fas fa-puzzle-piece"
    compact
    help={HELP}
  />
);

export default ConfiguracionComponentes;
